<template>
  <div class="col-12">
    <div class="row" v-if="segments.length">
      <div class="col-12">
        <section-separator has-border size="lg" no-margin-top="">
          {{$t('generic.segments')}}
        </section-separator>
      </div>
    </div>
    <div class="row" v-for="segment in segments">
      <div class="col-12" v-if="model.segments[segment.slug]">
        <fg-input :label="segment.name"
                  :required="segment.validation_min !== null"
                  :error="getError(segment.name)">
          <el-select multiple
                     :multiple-limit="segment.validation_max"
                     class="select-default"
                     :name="segment.name"
                     :placeholder="segment.name"
                     filterable
                     clearable
                     v-validate="segment.validation_min !== null ? 'required': ''"
                     v-model="model.segments[segment.slug]">
            <el-option class="select-default"
                       v-for="option in segment.segments"
                       :value="option.id"
                       :label="option.value"
                       :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </div>

    <div class="row" v-if="getJobSetting('job_field_show_hours')">
      <div class="col-6">
        <fg-input :label="$t('job.create.segments.hours.min')"
                  :error="getError($t('job.create.segments.hours.min'))">
          <el-select class="select-default"
                     :name="$t('job.create.segments.hours.min')"
                     :placeholder="$t('job.create.segments.hours.min')"
                     filterable
                     clearable
                     :error="getError($t('job.create.segments.hours.min'))"
                     v-validate="modelValidations.hours_min"
                     v-model="model.hours_min">
            <el-option class="select-default"
                       v-for="option in hoursOptions"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
        </fg-input>
      </div>
      <div class="col-6">
        <fg-input :label="$t('job.create.segments.hours.max')"
                  :error="getError($t('job.create.segments.hours.max'))">
          <el-select class="select-default"
                     :name="$t('job.create.segments.hours.max')"
                     :placeholder="$t('job.create.segments.hours.max')"
                     filterable
                     clearable
                     v-validate="modelValidations.hours_max"
                     v-model="model.hours_max">
            <el-option class="select-default"
                       v-for="option in hoursOptions"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </div>
    <div class="row" v-if="getJobSetting('job_field_show_salary')">
      <div class="col-12 mt-2">
        <section-separator has-border size="lg" no-margin-top="">
          {{$t('generic.salary')}}
        </section-separator>
      </div>
      <div class="col-12">
        <fg-input :label="$t('job.create.salaryType')">
          <salary-type-select v-model="model.salary_type" :name="$t('job.create.salaryType')">
          </salary-type-select>
        </fg-input>
      </div>
      <div class="col-6">
        <fg-input :placeholder="$t('generic.min')"
                  :name="$t('generic.min')"
                  :label="$t('generic.min')"
                  :error="getError($t('generic.min'))"
                  type="number"
                  v-validate="modelValidations.salary_min"
                  v-model="model.salary_min">
          <template slot="addonLeft">
            {{currencySymbol}}
          </template>
        </fg-input>
      </div>
      <div class="col-6">
        <fg-input :placeholder="$t('generic.max')"
                  type="number"
                  :name="$t('generic.max')"
                  :label="$t('generic.max')"
                  :error="getError($t('generic.max'))"
                  v-validate="modelValidations.salary_max"
                  v-model="model.salary_max">
          <template slot="addonLeft">
            {{currencySymbol}}
          </template>
        </fg-input>
      </div>
    </div>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui';
  import SalaryTypeSelect from 'src/components/Autocomplete/SalaryTypeSelect';
  import i18n from 'src/i18n';
  import { mapState } from 'vuex'
  const hoursOptions = [];

  for (let i = 0; i <= 40; i+=4) {
    hoursOptions.push({
      value: i,
      label: i18n.t('job.create.segments.hourOptions', { count: i })
    })
  }


  export default {
    name: 'job-create-segments',
    props: {
      segments: {
        type: Array,
        default: () => []
      },
      selectedSegments: {
        type: Object
      },
      extraInfo: {
        type: Object,
        default: () => ({})
      }
    },
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      SalaryTypeSelect
    },
    data() {
      return {
        model: {
          segments: {},
          hours_min: '',
          hours_max: '',
          salary_type: '',
          salary_min: null,
          salary_max: null
        },
        hoursOptions
      }
    },
    computed: {
      ...mapState({
        currencySymbol: state => state.config.currencySymbol
      }),
      getJobSetting() {
        return (name) => {
          let setting = this.$store.getters['config/getAppSetting'](name)
          return !!(setting && setting === '1');
        }
      },
      modelValidations() {
        return {
          hours_min: {
            max_value: this.model.hours_max || 100
          },
          hours_max: {
            min_value: this.model.hours_min || 1
          },
          salary_min: {
            min_value: 0,
            max_value: this.model.salary_max,
          },
          salary_max: {
            min_value: this.model.salary_min || 0,
          },
        }
      }
    },
    methods: {
      scrollTop() {
        window.scrollTo(0, 0)
      },
      async validate() {
        let res = await this.$validator.validateAll();
        this.$emit('on-validated', this.model);
        if (!res) {
          this.scrollTop()
        }
        return res;
      },
      mapSegments(segments) {
        let segmentMap = {};
        segments.forEach(segment => {
          segmentMap[segment.slug] = [];
        });
        return segmentMap;
      },
      buildDynamicSegments(selectedSegments) {
        if (!selectedSegments) return;
        let segmentMap = this.mapSegments(this.segments);
        let segments = {
          ...segmentMap,
          ...this.model.segments,
          ...selectedSegments
        };
        this.$set(this.model, 'segments', segments);
      }
    },
    mounted() {
      this.$watch('selectedSegments', this.buildDynamicSegments, {immediate: true})

      this.$watch('extraInfo', newVal => {
        if (!newVal) return;
        this.model = {
          ...this.model,
          ...newVal
        }
        this.buildDynamicSegments([]);
      }, { immediate: true })
    }
  }
</script>
<style>
</style>
